module.exports = __webpack_public_path__ + "make-logo-efa11fa8ec405c6c6b36c5c9f1e9e3d0.webp";